module.exports = __webpack_public_path__ + "img/calendar.a1a01430.svg";